<template>
  <div>
    <Card title="greeting-success"> 
      <div class="mx-auto mt-40 w-10/12 md:w-8/12 pt-30 md:pt-40 border-t border-grey2">
        <p class="text-24 font-bold text-primary mb-2" v-html="$t('tinaba-open-account-title')" />
        <p class="text-16 font-medium text-primary mb-5" v-html="$t('tinaba-open-account-content')" />
        <div class="max-w-buttonCover mx-auto">
          <a target="_blank" :href="$t('tinaba-open-account-link')" class="btn btn-blue text-20 block font-black w-full xs-max:h-16"> {{ $t("tinaba-open-account-cta") }} </a>
        </div>
      </div>
      <div class="phone-image lg-max:hidden ratio ro-120 absolute w-7/12 t-25 left-0">
        <vue-image :sources="[{ srcset: '/i-phone-x.png', media: '(max-width: 640px)' } ]" src="/i-phone-x.png" class="fit fit-contain z-20" />
      </div>
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card.vue'
import linkToPayData from '@/mixins/linkToPayData.js'
import VueImage from '@/components/Image'
export default {
  name: 'Success',
  components: {
    Card,
    VueImage
  },
  mixins: [linkToPayData]
}
</script>

<style>
  .phone-image {
    top: 30%;
    left: -33%;
  }
</style>